import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlugin2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="plugin-2, build"><path d="M4 5.75C4 4.23122 5.23122 3 6.75 3H8.25C9.76878 3 11 4.23122 11 5.75V7H4V5.75Z" fill="currentColor"/><path d="M13 5.75C13 4.23122 14.2312 3 15.75 3H17.25C18.7688 3 20 4.23122 20 5.75V7H13V5.75Z" fill="currentColor"/><path d="M2 12.25C2 10.1789 3.67893 8.5 5.75 8.5H18.25C20.3211 8.5 22 10.1789 22 12.25V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V12.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPlugin2;
